import { Box, VStack, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'

import { WidgetProps } from '../../types'

function WidgetItem({ text, image, sx }: WidgetProps): React.ReactElement {
  return (
    <VStack
      spacing="6"
      sx={{
        alignItems: 'center',
        py: 6,
        px: 6,
        bgColor: 'gray.50',
        borderRadius: '2xl',
        maxW: 'full',
        w: '265px',
        textAlign: 'center',
        ...sx,
      }}
    >
      {image && (
        <AspectRatio ratio={1} sx={{ w: '120px', mt: 2 }}>
          <Image src={image} alt="" layout="fill" />
        </AspectRatio>
      )}
      <Box
        sx={{
          fontSize: 'lg',
          flex: '1 1 auto',
          w: 'full',
        }}
      >
        {text}
      </Box>
    </VStack>
  )
}

export default WidgetItem
